import { SUPERSIZE_MY_EDIT_LABELS } from '../constants/supersizeMyEditAddons';

function getSupersizeMyEdit(value, cost, type, addonId) {
  return {
    captionValue: {
      cost,
      label: SUPERSIZE_MY_EDIT_LABELS[value],
      value,
      prefix: 'extrafootage',
      addonId
    },
    title: 'Supersize My Edit',
    type
  };
}

export default function getSupersizeMyEdits() {
  return (addons) => {
    const supersizeValue = addons && addons.SUPERSIZE_MY_EDIT || [];

    const supersizeValues = supersizeValue.map(
      (supersize) => getSupersizeMyEdit(
        supersize.value,
        supersize.cost,
        'SUPERSIZE_MY_EDIT',
        supersize.addonId
      )
    );

    return [...supersizeValues].filter(Boolean);
  };
}